/**
 * Thin FE telemetry wrapper — ENT-60.
 * Emits structured events to the analytics layer.
 * In production, wire EMIT_FN to the real analytics sink (Segment, Amplitude, etc.).
 * Until then, events are logged as structured console.info entries for observability.
 */

export function emitTelemetry(
  event: string,
  payload: Record<string, unknown>,
): void {
  // TODO ENT-60-T04: wire to actual analytics sink
  console.info('[telemetry]', event, { ...payload, _ts: Date.now() });
}
